import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-attention",
  "use": "icon-s-attention-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-attention\"><path d=\"M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0m0 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18m1 12v2h-2v-2zm0-9v8h-2V5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol